import Client from './client';

const api = {
  // LIST JOBS
  listJobCategories: () => Client.get('/job_categories'),
  // LIST TOOLS
  listToolsCategories: () => Client.get('/productivity_tools'),
};

export default api;
